import { render, staticRenderFns } from "./BaseDashboard.vue?vue&type=template&id=abc16d34"
import script from "./BaseDashboard.vue?vue&type=script&lang=js"
export * from "./BaseDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports